webpackJsonp([264693979713783],{

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quienes-somos-0.2ccf3f90.jpg";

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quienes-somos-1.bdd66bad.jpg";

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quienes-somos-2.0473bd9a.jpg";

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _quienesSomos = __webpack_require__(528);
	
	var _quienesSomos2 = _interopRequireDefault(_quienesSomos);
	
	var _quienesSomos3 = __webpack_require__(529);
	
	var _quienesSomos4 = _interopRequireDefault(_quienesSomos3);
	
	var _quienesSomos5 = __webpack_require__(530);
	
	var _quienesSomos6 = _interopRequireDefault(_quienesSomos5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuienesSomos = function (_React$Component) {
	    _inherits(QuienesSomos, _React$Component);
	
	    function QuienesSomos() {
	        _classCallCheck(this, QuienesSomos);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    QuienesSomos.prototype.componentDidMount = function componentDidMount() {
	        setTimeout(function () {
	            try {
	                window.jQuery('.flexslider').flexslider({
	                    directionNav: false,
	                    slideshowSpeed: 4000
	                });
	                window.jQuery('[data-toggle="tooltip"]').tooltip();
	            } catch (e) {}
	        }, 500);
	    };
	
	    QuienesSomos.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Quienes somos'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'about-us-slider' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Quienes somos'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Dismocan es una peque\xF1a empresa ubicada en El Sauzal, Tenerife. Nos especializamos en soluciones t\xE9cnicas de los procesos tanto constructivos como de mantenimiento de edificaciones.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Gracias al buen trabajo y el af\xE1n de siempre aportar el mejor conocimiento, contamos con el respaldo de grandes marcas en nuestro cat\xE1logo de productos.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flexslider' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'slides' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement('img', { src: _quienesSomos2.default, alt: 'office2' })
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement('img', { src: _quienesSomos4.default, alt: 'office1' })
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement('img', { src: _quienesSomos6.default, alt: 'office3' })
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'signup-cta' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'wrapper clearfix' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'No dudes en contactar con nosotros'
	                        ),
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/contacto', className: 'btn-shadow btn-shadow-info btn-shadow-lg mt-4' },
	                            'Contacto'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return QuienesSomos;
	}(_react2.default.Component);
	
	exports.default = QuienesSomos;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quienes-somos-index-js-0516029bf5ba2c2bd8b4.js